import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import moment from 'moment';
//Components
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
    Tabs,
    TabContainer
} from "@gpstrackit/react-controls";
import CustomCard from 'Components/Card';

//Actions
import { jiraSearchDetailsRequest, clearRedux } from 'Redux/actions';

//Styles
import './index.scss';

const UserDetails = (props) => {
    const { dataTime } = props

    const dispatch = useDispatch();

    const { messages } = useIntl();
    const { loading, openModal, result, user } = useSelector(state => state.userDetailsRedux)

    const closeModal = () => {
        dispatch(clearRedux("JIRA_DETAILS"))
    }

    useEffect(() => {
        if (openModal && user) {
            dispatch(jiraSearchDetailsRequest({
                developer: user?.name,
                dateRange: dataTime
            }))
        }
    }, [openModal])

    return (
        <Modal
            open={openModal}
            title={`${messages['jira_details_title']} - ${user?.name}`}
            size="small"
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
        >
            <ModalBody className="jira-details-view-modal">
                <div className="jira-details-view-container" style={{ height: '79vh', marginTop: -5 }}>
                    <Tabs>
                        <TabContainer className="jira-details-view-container-tab" index={0} label={messages['jira_details_task']}>
                            {
                                result?.times?.length ? (
                                    <>
                                        {result.times.map((time, index) => {
                                            let current = result.original.find((original) => original.jiraTask === time.jiraTask)
                                            return (
                                                <CustomCard
                                                    key={index}
                                                    hideButton
                                                    width={12}
                                                >
                                                    <div style={{ display: 'grid' }}>
                                                        <div>
                                                            <label className="jira-details-view-title">{messages['jira_details_task']}</label>
                                                            <a
                                                                className="jira-details-view-link"
                                                                href={`https://gpstrackit.atlassian.net/browse/${time.jiraTask}`}
                                                                target="_blank"
                                                            >
                                                                {time.jiraTask}
                                                            </a>
                                                        </div>
                                                        <div>
                                                            <label className="jira-details-view-title">{messages['jira_details_summary']}</label>
                                                            <span>{current.summary}</span>
                                                        </div>
                                                        <div>
                                                            <label className="jira-details-view-title">{messages['jira_details_story_points']}</label>
                                                            <span>{current.storyPoints}</span>
                                                        </div>
                                                        <div>
                                                            <label className="jira-details-view-title">{messages['jira_details_start']}</label>
                                                            <span>{moment(time.start).utc().format('LLL')}</span>
                                                        </div>
                                                        <div>
                                                            <label className="jira-details-view-title">{messages['jira_details_end']}</label>
                                                            <span>{moment(time.end).utc().format('LLL')}</span>
                                                        </div>
                                                    </div>
                                                </CustomCard>
                                            )
                                        })}
                                    </>
                                ) : <div className="jira-details-view-nodata"><span>{messages['jira_details_no_tasks']}</span></div>
                            }
                        </TabContainer>
                        <TabContainer className="jira-details-view-container-tab" index={1} label={messages['jira_details_rejections']}>
                            {
                                result?.rejections?.length ? (
                                    <>
                                        {result.rejections.map((item, index) => {
                                            return (
                                                <CustomCard
                                                    key={index}
                                                    hideButton
                                                    width={12}
                                                >
                                                    <div style={{ display: 'grid' }}>
                                                        <div>
                                                            <label className="jira-details-view-title">{messages['jira_details_task']}</label>
                                                            <a
                                                                className="jira-details-view-link"
                                                                href={`https://gpstrackit.atlassian.net/browse/${item.jiraTask}`}
                                                                target="_blank"
                                                            >
                                                                {item.jiraTask}
                                                            </a>
                                                        </div>
                                                        <div>
                                                            <label className="jira-details-view-title">{messages['jira_details_summary']}</label>
                                                            <span>{item.summary}</span>
                                                        </div>
                                                        <div>
                                                            <label className="jira-details-view-title">{messages['jira_details_rejections']}</label>
                                                            <span>{item.rejections}</span>
                                                        </div>
                                                        <div>
                                                            <label className="jira-details-view-title">{messages['jira_details_manual_rejections']}</label>
                                                            <span>{item.manualRejections}</span>
                                                        </div>
                                                    </div>
                                                </CustomCard>
                                            )
                                        })}
                                    </>
                                ) : (
                                    <div className="jira-details-view-nodata"><span>{messages['jira_details_no_rejected_tasks']}</span></div>
                                )
                            }
                        </TabContainer>
                        <TabContainer className="jira-details-view-container-tab" index={2} label={messages['jira_details_responsible']}>
                            {
                                result?.responsibleForTasks?.length ? (
                                    <>
                                        {result.responsibleForTasks.map((item, index) => {
                                            return (
                                                <CustomCard
                                                    key={index}
                                                    hideButton
                                                    width={12}
                                                >
                                                    <div style={{ display: 'grid' }}>
                                                        <div>
                                                            <label className="jira-details-view-title">{messages['jira_details_task']}</label>
                                                            <a
                                                                className="jira-details-view-link"
                                                                href={`https://gpstrackit.atlassian.net/browse/${item.jiraTask}`}
                                                                target="_blank"
                                                            >
                                                                {item.jiraTask}
                                                            </a>
                                                        </div>
                                                        <div>
                                                            <label className="jira-details-view-title">{messages['jira_details_summary']}</label>
                                                            <span>{item.summary}</span>
                                                        </div>
                                                    </div>
                                                </CustomCard>
                                            )
                                        })}
                                    </>
                                ) : (
                                    <div className="jira-details-view-nodata"><span>{messages['jira_details_no_rejected_tasks']}</span></div>
                                )
                            }
                        </TabContainer>
                        <TabContainer className="jira-details-view-container-tab" index={3} label={messages['jira_details_holidays']}>
                            {
                                result?.holidays?.length ? (
                                    <>
                                        {result.holidays.map((item, index) => {
                                            return (
                                                <CustomCard
                                                    key={index}
                                                    hideButton
                                                    width={12}
                                                >
                                                    <div style={{ display: 'grid' }}>
                                                        <div>
                                                            <label className="jira-details-view-title">{messages['jira_details_date']}</label>
                                                            <span>{moment(item).utc().format('LL')}</span>
                                                        </div>
                                                    </div>
                                                </CustomCard>
                                            )
                                        })}
                                    </>
                                ) : <div className="jira-details-view-nodata"><span>{messages['jira_details_no_holidays']}</span></div>
                            }
                        </TabContainer>
                    </Tabs>
                </div>
            </ModalBody>
            <ModalFooter>
                <div>
                    <Button
                        className="btn-dark-blue"
                        onClick={(e) => closeModal()}
                    >
                        {messages['close']}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default UserDetails;